import type { KpiCard } from "@wayflyer/flyui";
import type { ComponentProps } from "react";

import type { MetricType } from "../utils/types";

export interface OverviewKpiData {
  amount: Extract<ComponentProps<typeof KpiCard>["amount"], { value: number | null }>;
  change?: number;
  isRatio: boolean;
}

export type OverviewKpiMetric = { kpi?: OverviewKpiData };

export const overviewKpiData = (
  rawValue: string | number | null | undefined,
  metric: MetricType | undefined,
  withDecimal?: boolean,
  change?: number
): OverviewKpiData => {
  const parsed = rawValue == null || rawValue === "" ? NaN : Number(rawValue);
  const value = metric && Number.isFinite(parsed) ? parsed : null;
  const percentage = metric?.type === "PERCENTAGE";
  const withoutDecimals = value === null || Math.abs(percentage ? value * 100 : value) >= 100 || withDecimal === false;
  const digits = metric?.type === "COUNT" || withoutDecimals ? 0 : metric?.type === "CURRENCY" ? 2 : 1;
  const formatOptions = { minimumFractionDigits: digits, maximumFractionDigits: digits };
  const displayValue = metric?.type === "COUNT" && value !== null ? Math.trunc(value) : value;
  return {
    amount:
      metric?.type === "CURRENCY"
        ? { value: displayValue, currencyCode: metric.currencyCode, formatOptions }
        : { value: displayValue, formatOptions: { ...formatOptions, ...(percentage ? { style: "percent" } : {}) } },
    change: change !== undefined && Number.isFinite(change) ? change : undefined,
    isRatio: metric?.type === "RATE",
  };
};
